import type { CpModalKind } from '@bcf-vanilla-ts-v1-logic-worker-modals/shared/modal-kind.types';
import { provideSingleton } from '@bcf-vanilla-ts-v1-shared/di/provide-singleton';
import { asPromise } from '@bcf-vanilla-ts-v1-shared/misc/rx-helpers/as-promise';
import { provideBcfActivatedRoute, type BcfActivatedRoute } from './bcf-activated-route';
import { provideBcfActivatedUrl, type BcfActivatedUrl } from './bcf-activated-url';
import type { Params } from './types';

export type RedirectBackSnapshot = {
  routePath: string;
  queryParams: Params;
  fragment: string | undefined;
};

export type RedirectBackModalData = {
  modal: CpModalKind;
  modalParam?: string;
};

export class BcfRedirectBackSnapshot {
  constructor(
    private _activatedRoute: BcfActivatedRoute,
    private _activatedUrl: BcfActivatedUrl
  ) {}

  public async serializeSnapshot(): Promise<string> {
    const url: string = await asPromise(this._activatedUrl.url$);
    const queryParams: Params = await asPromise(this._activatedRoute.queryParams);
    const fragment: string | undefined = await asPromise(this._activatedRoute.fragment);

    const snapshot: RedirectBackSnapshot = {
      routePath: url,
      queryParams: queryParams,
      fragment: fragment
    };

    return btoa(encodeURIComponent(JSON.stringify(snapshot)));
  }

  public deserializeSnapshot(base64String: string): RedirectBackSnapshot {
    const urlEncodedString: string = atob(base64String);
    const jsonString: string = decodeURIComponent(urlEncodedString);
    const snapshot: RedirectBackSnapshot = JSON.parse(jsonString);
    return snapshot;
  }

  public fragmentToModal(snapshot: RedirectBackSnapshot): RedirectBackModalData | undefined {
    if (snapshot.fragment && snapshot.fragment.includes('modal-')) {
      const splited: string[] = snapshot.fragment.split('$');
      const modalName: CpModalKind = splited[0].replace('modal-', '') as CpModalKind;
      const modalParams: string | undefined = splited[1];
      return {
        modal: modalName,
        modalParam: modalParams
      };
    }
    return undefined;
  }
}
export function provideBcfRedirectBackSnapshot(): BcfRedirectBackSnapshot {
  return provideSingleton(
    BcfRedirectBackSnapshot,
    () => new BcfRedirectBackSnapshot(provideBcfActivatedRoute(), provideBcfActivatedUrl())
  );
}
